module.exports = __webpack_public_path__ + "img/team-photo.70e78580.jpg";